import React from 'react'
import Plus from './_Plus'
import {Flex} from './layout'

export default class ZoomControls extends React.Component{

    render(){
        return(
            <Flex>
                
                <Flex align="center" justify="center" onMouseDown={ () => { this.props.onClickPlus() }} style={{width:'2rem', height:'2rem'}}>
                    <Plus selected={true} />
                </Flex>
                
                <Flex align="center" justify="center" style={{width:'2rem', height:'2rem', marginLeft:'2rem'}}>
                    <div className="plus" onClick={ () => { this.props.onClickMinus() }}><span className='plus-h'></span></div>
                </Flex>

            </Flex>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/_ZoomControls.js